import React, { useRef } from 'react';
import { InfoIcon, Tooltip } from 'src/common';
import * as S from './InfoHint.styles';

interface InfoHintProps {
  children: React.ReactNode;
  tooltipText: string;
  place?: 'top' | 'bottom' | 'left' | 'right';
  maxWidth?: number;
  noIcon?: boolean;
}

const InfoHint: React.FC<InfoHintProps> = ({
  children,
  tooltipText,
  place = 'top',
  maxWidth = 400,
  noIcon = false,
}) => {
  const tooltipId = useRef(`info-tooltip-${Math.random().toString(36).substr(2, 9)}`);

  return (
    <>
      <Tooltip
        dataId={tooltipId.current}
        dataHtml={tooltipText}
        place={place}
        maxWidth={maxWidth}
        noIcon
        delayShow={200}
      />
      <S.Container data-tooltip-id={tooltipId.current} data-tooltip-html={tooltipText}>
        {children}
        {!noIcon && <InfoIcon cursorDefault />}
      </S.Container>
    </>
  );
};

export default InfoHint;
